import { render, staticRenderFns } from "./BrandDetectionReport.vue?vue&type=template&id=ba619512&scoped=true&"
import script from "./BrandDetectionReport.vue?vue&type=script&lang=js&"
export * from "./BrandDetectionReport.vue?vue&type=script&lang=js&"
import style0 from "./BrandDetectionReport.vue?vue&type=style&index=0&id=ba619512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba619512",
  null
  
)

export default component.exports